import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { EventWaitlistFilters } from '../../../../../../../../../models/scheduled-event';
import { EventType } from '../../../../../../../../../models/event-type';
import { EventTypeStatus } from '../../../../../../../../../models/event-type-enums';
import { LocationService } from '../../../../../../../../../services/location/location.service';
import { AccountService } from '../../../../../../../../../services/account/account.service';


@Component({
  selector: 'app-event-waitlists-filters-modal',
  templateUrl: './event-waitlists-filters-modal.component.html',
  styleUrls: ['./event-waitlists-filters-modal.component.css']
})
export class EventWaitlistsFiltersModalComponent implements OnInit {
  @Input() inputFilters: EventWaitlistFilters;
  @Input() eventTypes: EventType[];
  @Input() savedCallback: (newFilters: EventWaitlistFilters) => undefined;

  public filters: EventWaitlistFilters;

  public readonly EventTypeStatus = EventTypeStatus;

  constructor(
    public activeModal: NgbActiveModal,
    public locationService: LocationService,
    public accountService: AccountService
  ) {}

  ngOnInit() {
    // Copy so the page's filters only change on Apply.
    this.filters = {};

    for (const key of Object.keys(this.inputFilters)) {
      this.filters[key] = this.inputFilters[key];
    }
  }

  public handleSubmit() {
    if (this.filters.first_start_min === '') { this.filters.first_start_min = undefined; }
    if (this.filters.first_start_max === '') { this.filters.first_start_max = undefined; }

    this.savedCallback(this.filters);
    this.activeModal.close();
  }

  public handleClearAll() {
    this.filters = {
      location_id: this.accountService.getMyAccount().default_gym_id
    };
  }

  public setShowAllEvents(showAll: boolean) {
    this.filters.has_active_waitlist = showAll ? false : undefined;
  }
}
